import { z } from 'zod'

// Кто смотрит — единственный источник контура сессии во фронте (`GET /api/auth/me`,
// same-origin). Контуров два и они независимы (00-architecture § 3): сотрудник с
// hub-сессией employee-backend и заказчик с customer-сессией хаба. Обе cookie
// httpOnly — различить их из JS больше нечем, поэтому контур называет бэкенд.
export const SessionKindSchema = z.enum(['employee', 'customer'])
export type SessionKind = z.infer<typeof SessionKindSchema>

// Wire `/api/auth/me` (huma, конверт { data }). kind приходит вместе с
// customer-контуром бэка; без него сессия сотрудничья, как было.
export const MeSchema = z.object({
  sub: z.string(),
  kind: SessionKindSchema.optional(),
  name: z.string().optional(),
  full_name: z.string().optional(),
  username: z.string().optional(),
  // hub-роль сотрудника (admin|employee) либо `client` у заказчика.
  role: z.string().optional(),
  // Компания заказчика (claim customer-сессии); у сотрудника пусто.
  company_id: z.string().optional(),
  company_name: z.string().optional(),
  // Продукты, выданные аккаунту заказчика (claim `products`) — по ним свитчер
  // рисует плитки. Словарь чужой (владелец — хаб), enum'ом не нарроим.
  products: z.array(z.string()).optional(),
})
export type Me = z.infer<typeof MeSchema>

export interface Session {
  id: string
  kind: SessionKind
  name: string
  role?: string
  // Заказчик: его компания и выданные продукты. Сотрудник: пусто — ему доступна
  // вся экосистема и все компании студии.
  companyId?: string
  companyName?: string
  products: string[]
}

export function sessionFromMe(me: Me): Session {
  const kind: SessionKind = me.kind ?? (me.role === 'client' ? 'customer' : 'employee')
  return {
    id: me.sub,
    kind,
    name:
      me.full_name || me.name || me.username || (kind === 'customer' ? 'Заказчик' : 'Сотрудник'),
    products: me.products ?? [],
    ...(me.role ? { role: me.role } : {}),
    ...(me.company_id ? { companyId: me.company_id } : {}),
    ...(me.company_name ? { companyName: me.company_name } : {}),
  }
}

export const isCustomer = (session: Session | null | undefined): boolean =>
  session?.kind === 'customer'
